export default __webpack_public_path__ + "static/media/curve_dai_usdc_usdt.2ab900f1.svg";